export default "__VITE_ASSET__DxGZUb$A__"